import Axios from 'axios';
import config from '@platform/shared/config';
import {
    normalizeKzParty,
    normalizeRuParty,
    planPartyLookup,
    type PartyCountry,
    type PartySuggestion,
} from './dadata-party';

export {
    partySuggestionToGridOption,
    planPartyLookup,
    settingsPartyCountry,
    type PartySuggestion,
} from './dadata-party';

const ddAxios = Axios.create({
    baseURL: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/',
    headers: {
        Authorization: `Token ${config.daDataToken}`,
        Accept: 'application/json',
    },
});

type DaDataOrgResponse = {
    suggestions: Array<{
        value: string;
        unrestricted_value: string;
        data: any;
    }>;
};

type DaDataAddressResponse = {
    suggestions: Array<{
        value: string;
        unrestricted_value: string;
        data: any;
    }>;
};

type DataBankResponse = {
    suggestions: Array<{
        value: string;
        unrestricted_value: string;
        data: any;
    }>;
};

export const getOrgList = (query: string, count = 15) =>
    ddAxios.post<DaDataOrgResponse>('suggest/party', { query, count }).then((res) => res.data.suggestions);

/**
 * Поиск контрагента по стране организации.
 * Номер — findById с запасной страной, название — suggest только основной страны.
 */
export async function resolveParty(
    country: string | null | undefined,
    query: string,
    count = 15
): Promise<PartySuggestion[]> {
    const plan = planPartyLookup(country, query);
    if (plan.kind === 'none') return [];
    const q = query.trim();
    if (plan.kind === 'suggest') return suggestParty(plan.country, q, count);
    for (const step of plan.countries) {
        const found = await findPartyById(step, q);
        if (found.length) return found;
    }
    return [];
}

function suggestParty(country: PartyCountry, query: string, count: number) {
    const path = country === 'RU' ? 'suggest/party' : 'suggest/party_kz';
    return ddAxios.post<DaDataOrgResponse>(path, { query, count }).then((res) =>
        (res.data.suggestions ?? []).map((item) => (country === 'RU' ? normalizeRuParty(item) : normalizeKzParty(item)))
    );
}

function findPartyById(country: PartyCountry, query: string) {
    const path = country === 'RU' ? 'findById/party' : 'findById/party_kz';
    return ddAxios.post<DaDataOrgResponse>(path, { query }).then((res) =>
        (res.data.suggestions ?? []).map((item) => (country === 'RU' ? normalizeRuParty(item) : normalizeKzParty(item)))
    );
}

export const getAddressesList = (query: string, count = 15, country?: string | null) => {
    const body: { query: string; count: number; locations?: Array<{ country_iso_code: string }> } = { query, count };
    if (country === 'KZ' || country === 'UZ') {
        body.locations = [{ country_iso_code: country }];
    }
    return ddAxios.post<DaDataAddressResponse>('suggest/address', body).then(({ data }) => data.suggestions);
};

export const getBankList = (query: string, count = 15) =>
    ddAxios.post<DataBankResponse>('suggest/bank', { query, count }).then(({ data }) => data.suggestions);
